import { render, staticRenderFns } from "./dialogAuctionRule.vue?vue&type=template&id=4099d238&scoped=true"
var script = {}
import style0 from "./dialogAuctionRule.vue?vue&type=style&index=0&id=4099d238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4099d238",
  null
  
)

export default component.exports